import { render, staticRenderFns } from "./effectiveData.vue?vue&type=template&id=250e1f3a&scoped=true&"
import script from "./effectiveData.vue?vue&type=script&lang=js&"
export * from "./effectiveData.vue?vue&type=script&lang=js&"
import style0 from "./effectiveData.vue?vue&type=style&index=0&id=250e1f3a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250e1f3a",
  null
  
)

export default component.exports